<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model[detailName]"
  reportName="CostCenter"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="[]"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="columns && columns.length > 0">
    <div class="row">
      <div class="col treeview" *ngIf="formulaInfo && formulaInfo.length > 0">
        <kendo-treeview
          [nodes]="formulaInfo"
          textField="Title"
          [hasChildren]="hasChildren"
          [children]="fetchChildren"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          (selectionChange)="addItem($event)">
        </kendo-treeview>
      </div>
      <div style="width: 100vmin" class="col">
        <form-control-model
          [columns]="columns"
          [group]="formGroup"
          [model]="model[detailName]"
          (valueChangeByApiName)="onValueChangeByApiName($event)"
          (valueChangeWithName)="valueChangeWithName($event)">
        </form-control-model>
      </div>
    </div>
  </ng-container>
</dynamic-form>
